<template>
    <div class="main">
        <van-overlay :show="show" @click="show = true">
            <div class="wrapper" @click.stop>
                <div class="block">
                    <div class="header">撤回</div>
                    <div class="header">确认撤回1233311</div>
                    <div class="contentText">提示：11111111</div>
                    <div class="footer">
                        <div>取消</div>
                        <div>确认</div>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                show: false
            }
        }
    }
</script>

<style lang="less" scoped>
.main {
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        width: 300px;
        height: 300px;
        background-color: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .header {
            font-size: 18px;
            color: #000000;
            padding: 20px 0px;
        }
        .contentText {
            font-size: 14px;
            color: #666666;
        }
        .footer {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 100px;
            div {
                background: #118BF5;
                color: #fff;
                font-size: 14px;
                height: 40px;
                width: 20%;
                border-radius: 5px;
                text-align: center;
                line-height: 40px;
            }
        }
    }
}
</style>
